/**
 * §9 FAQ accordion — /pro-member-v12. Aria pinned values §9. Legacy anchor: pm11-faq.
 * One item open at a time. Questions/answers arrive as server-rendered nodes
 * (copy tokens already resolved); the FAQPage JSON-LD is built from the same list.
 */

'use client';

import { useState, type ReactNode } from 'react';
import { PM12Icon } from '../icons';

export default function PM12Faq({
  eyebrow,
  heading,
  items,
}: {
  eyebrow: string;
  heading: string;
  items: { q: ReactNode; a: ReactNode }[];
}) {
  const [open, setOpen] = useState<number | null>(null);
  return (
    <section className="pm12-section pm12-faq" id="pm11-faq" aria-labelledby="pm12-faq-h2">
      <div className="pm12-container pm12-container--narrow">
        <p className="pm12-eyebrow">{eyebrow}</p>
        <h2 id="pm12-faq-h2" className="pm12-h2">{heading}</h2>
        <div className="pm12-faq__list">
          {items.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className={`pm12-faq__item${isOpen ? ' pm12-faq__item--open' : ''}`}>
                <h3 className="pm12-faq__q-wrap">
                  <button
                    type="button"
                    className="pm12-h3 pm12-faq__q"
                    aria-expanded={isOpen}
                    aria-controls={`pm12-faq-a-${i}`}
                    id={`pm12-faq-q-${i}`}
                    onClick={() => setOpen(isOpen ? null : i)}
                  >
                    <span>{item.q}</span>
                    <PM12Icon name="chevron" size={20} className="pm12-faq__chevron" />
                  </button>
                </h3>
                <div id={`pm12-faq-a-${i}`} role="region" aria-labelledby={`pm12-faq-q-${i}`} className="pm12-faq__a" hidden={!isOpen}>
                  <p className="pm12-body">{item.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
